import { supabase } from './supabase';

const getToken = () => localStorage.getItem('cafegoo_admin_token');

class AdminService {
  // ============ GLOBAL STATS ============
  async getGlobalStats() {
    try {
      // Total users
      const { data: totalUsersRes } = await supabase.rpc('admin_count_users', { p_admin_token: getToken() });
      const totalUsers = totalUsersRes?.success ? totalUsersRes.count : 0;

      // Active businesses
      const { data: activeBusinesses } = await supabase.rpc('admin_count_businesses', {
        p_admin_token: getToken(), p_is_active: true,
      });

      const { data: totalBusinesses } = await supabase.rpc('admin_count_businesses', {
        p_admin_token: getToken(),
      });

      // Total revenue (bu ay)
      const startOfMonth = new Date();
      startOfMonth.setDate(1);
      startOfMonth.setHours(0, 0, 0, 0);

      const { data: revRes } = await supabase.rpc('admin_get_revenue_logs_full', {
        p_admin_token: getToken(), p_since: startOfMonth.toISOString(),
      });
      const revenueData = revRes?.success ? revRes.rows : [];

      const totalRevenue = revenueData?.reduce((sum, r) => sum + parseFloat(r.amount), 0) || 0;

      // User growth (bu ay)
      const { data: newUsersRes } = await supabase.rpc('admin_count_users', {
        p_admin_token: getToken(), p_since: startOfMonth.toISOString(),
      });
      const newUsersThisMonth = newUsersRes?.success ? newUsersRes.count : 0;

      return {
        totalUsers,
        activeBusinesses,
        totalBusinesses,
        totalRevenue,
        newUsersThisMonth,
      };
    } catch (error) {
      console.error('Error fetching global stats:', error);
      throw error;
    }
  }

  // ============ USER GROWTH DATA ============
  async getUserGrowthData(days = 30) {
    try {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - days);

      const { data: res } = await supabase.rpc('admin_get_user_signup_dates', {
        p_admin_token: getToken(), p_since: startDate.toISOString(),
      });
      const data = res?.success ? res.rows : [];

      // Günə görə qruplaşdır
      const groupedData = {};
      data?.forEach((user) => {
        const date = new Date(user.created_at).toLocaleDateString('az-AZ');
        groupedData[date] = (groupedData[date] || 0) + 1;
      });

      return Object.entries(groupedData).map(([date, count]) => ({
        date,
        users: count,
      }));
    } catch (error) {
      console.error('Error fetching user growth:', error);
      throw error;
    }
  }

  // ============ APPLICATIONS ============
  async getPendingApplicationsCount() {
    try {
      const { data, error } = await supabase.rpc('admin_get_applications', { p_admin_token: getToken(), p_status: 'pending' });
      if (error) throw error;
      return data?.success ? data.rows.length : 0;
    } catch (error) {
      console.error('Error getting pending applications:', error);
      return 0;
    }
  }

  async getAllApplications() {
    try {
      const { data, error } = await supabase.rpc('admin_get_applications', { p_admin_token: getToken() });
      if (error) throw error;
      return data?.success ? data.rows : [];
    } catch (error) {
      console.error('Error getting applications:', error);
      return [];
    }
  }

  async approveApplication(applicationId, adminId, subscriptionMonths) {
    try {
      const { data, error } = await supabase.rpc('admin_approve_application', {
        p_admin_token: getToken(), p_application_id: applicationId, p_subscription_months: subscriptionMonths,
      });
      if (error) throw error;
      if (!data?.success) throw new Error(data?.error);

      return { success: true, business: { id: data.business_id } };
    } catch (error) {
      console.error('Error approving application:', error);
      return { success: false, error: error.message };
    }
  }

  async rejectApplication(applicationId, adminId, reason) {
    try {
      const { data, error } = await supabase.rpc('admin_reject_application', {
        p_admin_token: getToken(), p_application_id: applicationId, p_reason: reason,
      });
      if (error) throw error;
      if (!data?.success) throw new Error(data?.error);

      return { success: true };
    } catch (error) {
      console.error('Error rejecting application:', error);
      return { success: false, error: error.message };
    }
  }

  // ============ SYSTEM LOG ============
  // system_logs cədvəlini yaratmaq üçün Supabase SQL Editor-da işlədin:
  // create table if not exists system_logs (
  //   id uuid default gen_random_uuid() primary key,
  //   admin_id uuid, action text, target_type text,
  //   target_id text, details jsonb, created_at timestamptz default now()
  // );
  async logAction(adminId, action, targetType, targetId = null, details = null) {
    try {
      const token = localStorage.getItem('cafegoo_admin_token');
      await supabase.rpc('admin_log_action', {
        p_admin_token: token,
        p_action: action,
        p_target_type: targetType,
        p_target_id: targetId ? String(targetId) : null,
        p_details: details || {},
      });
    } catch (_) {
      // log fails silently — don't break main flow
    }
  }
}

const adminService = new AdminService();
export default adminService;